import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function VolunteerForm({ event = null, onDone = null }) {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: "", event: event ? event.name : "", message: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!event) {
      api.get("/events")
        .then((r) => setEvents(r.data.filter((e) => e.status !== "completed" && e.status !== "closed")))
        .catch(() => {});
    }
  }, [event]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/volunteers", form);
      toast.success("Thank you for volunteering! Our team will reach out soon.");
      setForm({ name: "", email: "", phone: "", city: "", event: event ? event.name : "", message: "" });
      if (onDone) onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <p className="font-mono text-[10px] tracking-[0.25em] text-slate-500">CHOOSE YOUR EVENT</p>
      {event ? (
        <p data-testid="volunteer-event-locked" className="rounded-lg border border-brand-olive/40 bg-brand-olive/10 px-4 py-2.5 text-sm font-semibold text-brand-olive">
          {event.name} — {event.date_text}
        </p>
      ) : (
        <select data-testid="volunteer-event" required className="input-k" value={form.event} onChange={(e) => setForm({ ...form, event: e.target.value })}>
          <option value="">Select an event to volunteer for</option>
          {events.map((e) => <option key={e.slug} value={e.name}>{e.name} — {e.date_text}</option>)}
        </select>
      )}
      <div className="grid gap-4 sm:grid-cols-2">
        <input data-testid="volunteer-name" required placeholder="Full name" className="input-k" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="volunteer-phone" required placeholder="Phone / WhatsApp" className="input-k" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <input data-testid="volunteer-email" required type="email" placeholder="Email" className="input-k" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <input data-testid="volunteer-city" placeholder="City" className="input-k" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
      </div>
      <textarea data-testid="volunteer-message" rows={2} placeholder="How would you like to help? (route support, hydration crew, registration desk, media...)" className="input-k" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
      <button data-testid="volunteer-submit" disabled={busy} className="btn-kinetic btn-primary-k w-full justify-center disabled:opacity-60">
        {busy ? "Submitting..." : "SIGN UP AS VOLUNTEER"}
      </button>
    </form>
  );
}
